import '../sceneTokens.css';
import './sections.css';

/* FeatureHeader: the shared shell of the four FEATURE sections (PAGE
   STRUCTURE v3, 2026-09-29): F1 Connect your curriculum, F2 Assessments,
   F3 Ask Buffy, F4 Assign practice and track progress.

   One row: a text column (a big two-tone heading, then one sub line) on one
   side, the feature's visual (tile / scene / video box)
   on the other. Alternate sides down the page: F1 left, F2 right, F3 left,
   F4 right. Under 1100px it stacks: text above, visual below.

   Props
     n          1-4, the feature's place (owner 2026-09-29, round 2: no
                numeral is shown any more; n only names the default id)
     title      the heading (h2)
     sub        one sub line (optional)
     side       'left' | 'right': where the TEXT column sits (default 'left')
     id         optional; the h2 gets `${id}-h` for anchors and aria (default
                `cxs-f${n}`)
     className  extra class on the <section> (for per-feature tweaks)
     after      optional node under the sub, in the text column (the
                student view's three short points)
     children   the visual

   Styles live in sections.css (.cxs-feature*). The text column is 340px by
   default; a feature can set --feature-copy on its className to change it.
   The visual column takes the rest (min-width: 0), vertically centered with
   the text. The section itself carries the page rhythm (.cxs-section: 88px
   top and bottom, 56 on phones) and the scene tokens (.cx-root).

   Two optional props (schools preview, 2026-09-30); the defaults keep the
   teacher page's output unchanged:
     as         the title's tag (default 'h2'); the schools page nests its
                rows under h2 chapters with as="h3"
     labelled   default true: the section is a region named by its title
                (aria-labelledby); false leaves the section unnamed */
export default function FeatureHeader({ n, title, sub, side = 'left', id, className = '', after = null, as: Heading = 'h2', labelled = true, children }) {
  const hid = `${id || `cxs-f${n}`}-h`;
  return (
    <section className={`cx-root cxs-section cxs-feature is-text-${side === 'right' ? 'right' : 'left'} ${className}`} aria-labelledby={labelled ? hid : undefined}>
      <div className="cxs-wrap cxs-feature-row">
        <div className="cxs-feature-copy">
          <Heading id={hid} className="cxs-feature-h">{title}</Heading>
          {sub ? <p className="cxs-feature-sub">{sub}</p> : null}
          {after}
        </div>
        <div className="cxs-feature-visual">{children}</div>
      </div>
    </section>
  );
}
